var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 655,
    height: 655,
    viewBox: "0 0 655 655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Cloud-White"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 655,
    height: 655
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cloud-White",
    clipPath: "url(#clip-Cloud-White)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3",
    "data-name": "SVGID 3",
    d: "M401,327.5a109.177,109.177,0,0,0-76.211-104.087A109.178,109.178,0,0,0,177.6,76.216a109.174,109.174,0,0,0-208.161,0A109.18,109.18,0,0,0-158.037,95.927a109.2,109.2,0,0,0-19.71,127.486A109.161,109.161,0,0,0-254,327.5a109.177,109.177,0,0,0,76.211,104.087,109.2,109.2,0,0,0,19.709,127.486A109.179,109.179,0,0,0-30.6,578.784a109.174,109.174,0,0,0,208.161,0,109.178,109.178,0,0,0,147.187-147.2A109.161,109.161,0,0,0,401,327.5Z",
    transform: "translate(254)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud1);
export default __webpack_public_path__ + "static/media/cloud-1.dffcfa266e5ef0c538e7c3a50aa516ff.svg";
export { ForwardRef as ReactComponent };